import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from "@angular/forms";
import { MatSelect } from '@angular/material';
import { Router } from '@angular/router';
import { BatchFileError, BatchFileSucces, BatchImportPayoutProcess, ConfigurationImportProcess, DataField, DataValidation, DataValidationTable, FieldValidation, FileValidation, PaymentVersion, PayoutDetails, Table, TableData, Template, UploadedFile } from '../../../_models';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';
import { AppConfig, CustomValidators } from '../../../_helpers/index';
import { ConfigurationService, NewImportProcessService, PaymentProcessService, PayoutService, ProcessService } from '../../../_services';
import { catchError, switchMap, timeout, takeUntil, tap } from 'rxjs/operators';
import { Observable, Subject, Subscription, of, timer } from 'rxjs';
import { ImportFileOptions, ImportOptions } from '../../../sharedcomp/constans/importProcess.constans';
import { icons } from '../../../sharedcomp/constans/icons.constans';
import { ErrorFileMessageMap } from '../../../_enums/index';
import { HttpResponse } from '@angular/common/http';
import { EventEmitter } from 'protractor';
import { BatchFilesDetails } from 'src/app/_models/batchProcess.interface';
import { duplicateWarningMessage } from '../../../sharedcomp/utils/import-process-utils';

@Component({
    selector: 'app-newpaymentcustomerimport',
    templateUrl: './newpaymentcustomerimport.component.html',
    styleUrls: ['../../../../assets/css/new-buttons-theme.css','./newpaymentcustomerimport.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class newpaymentcustomerimport implements OnInit  {
    customerPuplic_key: string;
  user_public_id: string;
  userNameProcess: string;
  userEmail: string;

  private destroy$ = new Subject<void>();

  icons: Record<string, Record<string, string>>;
  urlProcessPath: string;

  stepSelection: number = 1;

  @Input() urlConfigType: keyof typeof ImportFileOptions;
  @Input() configurationData: ConfigurationImportProcess;

  @ViewChild('fileDropRef') fileDropRef: ElementRef;

  // first step variables
  templateSelectForm: FormGroup;
  isTemplateStepComplete: boolean = false;
  isModifyStep1ButtonAvailable: boolean = true;

  selectedTemplateHelpFile: string = "";
  selectedTemplateHelpFilePath: string = "";
  selectedTemplateLabel: string = "";
  formatsSelected: string = "";

  source: Record<string, any>[];
  templateColumns: string[];

  // second step variables
  fileSelectForm: FormGroup;
  isFileStepComplete: boolean = false;

  exportTemplatesList: Template[];
  uploadedFile: UploadedFile;
  validatedFile: FieldValidation | {} = {};

  idBatch: string;
  lastIdBatch: string;


  isFileUploadAvailable: boolean = true;
  loadingActivatedMessage: boolean = false;
  errorActivatedMessage: boolean = false;
  errorFileMessage: string = "";
  sucessActivatedMessage: boolean = false;

  dataPrevalidationRecords: DataField | {};
  fieldPrevalidationWarningMessage: boolean = false;

  prevalidationColumns: string[];
  prevalidationSource: { [key: string]: TableData }[];

  // third step variables
  fieldMappingForm: FormGroup;
  isFieldMappingComplete: boolean = false;

  fileRenderSource: Record<string, any>[];
  fileRenderColumns: string[];

  amountAttributes: number;

  // fourth step variables
  fieldMappingLoadingMessage: boolean = false;
  fieldMappingErrorMessage: boolean = false;
  confirmImportAvailable: boolean = false;
  idBatchConfirm: string;
  formDataFromFieldValidation: FormData;

  infoByError: boolean = false;
  designVersion: string;

  constructor(
    private router: Router
    , private formBuilder: FormBuilder
    , private spinnerService: Ng4LoadingSpinnerService
    , private configurationService: ConfigurationService
    , private newImportProcessService: NewImportProcessService
    , private payoutService: PayoutService
    , private paymentProcessService: PaymentProcessService
    , private processService: ProcessService
  ) {
    this.icons = icons;
    this.initTemplateSelectForm();
    this.initFileSelectForm();
    this.initFieldMappingForm();
  }

  ngOnInit() {
   
    this.spinnerService.show();
    this.checkCredentials();
    this.urlProcessPath = 'payment_process';
    // this.urlProcessPath = ImportFileOptions[this.urlConfigType].PROCESS;


    // check if @Input() configurationData was passed as null or undefined from the parent component
    if (this.configurationData === null || this.configurationData === undefined) {
      // this.getImportConfiguration();
      this.getImportConfigurationCustomer()
    } else {
      this.getConfigurationFromInput(this.configurationData);
    }
  }

  checkCredentials() {
    this.designVersion = localStorage.getItem('designVersion');
    const companyIdLocalStorage = localStorage.getItem('companyId');
    const applicationLocalStorage = localStorage.getItem('application');
    const isCorporateLocalStorage = localStorage.getItem('isCorporate');
    const subcompanyIdLocalStorage = localStorage.getItem('subcompanyId');
   

    if ((companyIdLocalStorage != null || companyIdLocalStorage !== '') && (applicationLocalStorage != null || applicationLocalStorage !== '')) {

      if (isCorporateLocalStorage === 'Yes') {
        this.customerPuplic_key = subcompanyIdLocalStorage;
      } else {
        this.customerPuplic_key = companyIdLocalStorage;
      }

      this.user_public_id = localStorage.getItem('userId');
      this.userNameProcess = localStorage.getItem('username');
      this.userEmail = localStorage.getItem('userEmail');
    } else {
      this.router.navigate(['/home']);
    }
  }

  skipImportFile() {
    const path = '/customers';
    if (path) {
      this.customRedirect(path);
    };
  }

  // init forms
  initTemplateSelectForm() {
    this.templateSelectForm = this.formBuilder.group({
      templateOption: new FormControl('Seleccione su plantilla', [Validators.required, CustomValidators.templateValidator])
    });
  }

  initFileSelectForm() {
    this.fileSelectForm = this.formBuilder.group({
      fileOption: new FormControl('null', [Validators.required, CustomValidators.templateValidator]),
      fileValid: new FormControl(false, [Validators.required, CustomValidators.fileValid])
    });
  }

  initFieldMappingForm() {
    this.fieldMappingForm = this.formBuilder.group({
      fieldList: this.formBuilder.array([], [CustomValidators.validateArray])
    });
  }

  //  forms' setters and getters
  get fileOptionControl(): string { return this.fileSelectForm.get('fileOption').value; }
  set fileOptionControl(value: string) {
    this.fileSelectForm.get('fileOption').setValue(value);
  }

  get fileValidControl(): boolean { return this.fileSelectForm.get('fileValid').value; }
  set fileValidControl(value: boolean) {
    this.fileSelectForm.get('fileValid').setValue(value);
  }

  get fieldListArray(): FormArray { return this.fieldMappingForm.get('fieldList') as FormArray; }
  set fieldListArray(value) {
    this.fieldMappingForm.get('fieldList').setValue([]);
  }

  // getImportConfiguration() {
  //   const urlConfig = 'payment_process_services.configuration';
  //   // const urlConfig = ImportFileOptions[this.urlConfigType].CONFIG;

  //   this.configurationService.getImportConfiguration(this.customerPuplic_key, urlConfig)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(data => {
        
  //       this.exportTemplatesList = data.values.import_process.templates || [];
  //       this.spinnerService.hide();
  //     }, error => {
  //       console.error('Failed! while trying to get import configuration. ' + error);
  //       this.spinnerService.hide();
  //     });
  // }

  getImportConfigurationCustomer() {
    const urlConfig = 'debtors_import.configuration';
    // const urlConfig = ImportFileOptions[this.urlConfigType].CONFIG;

    this.configurationService.getImportConfigurationCustomer(this.customerPuplic_key, urlConfig)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.exportTemplatesList = data.values.import_process.templates || [];
        this.spinnerService.hide();
      }, error => {
        console.error('Failed! while trying to get import configuration. ' + error);
        this.spinnerService.hide();
      });
  }

  getConfigurationFromInput(configurationData: ConfigurationImportProcess) {
    this.exportTemplatesList = configurationData.values.import_process.templates || [];;
    this.spinnerService.hide();
  }

  initStep2() {
    this.fileOptionControl = 'null';
    this.fileValidControl = false;

    this.isFileUploadAvailable = true;

    this.errorActivatedMessage = false;
    this.sucessActivatedMessage = false;

    this.loadingActivatedMessage = false;
    this.fieldPrevalidationWarningMessage = false;
    this.prevalidationColumns = null;
    this.prevalidationSource = null;
  }

  backToStep1() {
    this.resetTemplateStep3();
    this.resetTemplateStep2();
    this.resetTemplateStep1();
    this.resetTemplateStep4();
  }

  backToStep2() {
    this.resetTemplateStep3();
    this.resetTemplateStep2();
    this.resetTemplateStep4();
  }

  resetTemplateStep1() {
    this.isTemplateStepComplete = false;
    this.stepSelection = 1;
    this.initStep2();
  }

  resetTemplateStep2() {
    this.fileOptionControl = 'null';
    this.fileValidControl = false;
    if (this.fileDropRef !== undefined) {
      this.fileDropRef.nativeElement.value = '';
    }
    this.uploadedFile = {};
    this.dataPrevalidationRecords = {};
    this.validatedFile = {};
    this.isFileStepComplete = false;
    this.stepSelection = 2;
    this.initStep2();
    this.initFieldMappingForm();
  }

  resetTemplateStep3() {
    this.isFieldMappingComplete = false;
    this.idBatchConfirm = '';
    this.stepSelection = 3;
    this.resetTemplateStep4();
  }

  resetTemplateStep4() {
    this.infoByError = false;
    this.fieldMappingLoadingMessage = false;
    this.fieldMappingErrorMessage = false;
    this.confirmImportAvailable = false;
  }

  // create custom form data, metadata field is optional and depends on parameters addMetadata and metadataInfo
  createFormData(fileInfo: UploadedFile, addFileToUpload: boolean = false, addDescription: boolean = false, addMetadata: boolean = false, metadataInfo: string = null): FormData {
    const formData = new FormData();
    if (addFileToUpload) {
      formData.append('file_to_upload', new Blob([fileInfo.file], { type: fileInfo.type }), fileInfo.name);
    }
    formData.append('template', fileInfo.template);
    formData.append('customer_id', fileInfo.customer);


    if (addDescription) {
      formData.append('description', fileInfo.description);
    }

    if (addMetadata && metadataInfo == null) {
      formData.append('metadata', fileInfo.metadata);
    } else if (addMetadata && metadataInfo != null) {
      formData.append('metadata', metadataInfo);
    }

    return formData;
  }

  changeTemplate(event: string) {
    const templateId = event;
    const importFilePath = '../../assets/helpfiles/payment-import';
    // const importFilePath = ImportFileOptions[this.urlConfigType].IMPORT_FILE_PATH;
    const selectedTemplate = this.exportTemplatesList.filter(el => el.id === templateId)[0];
    this.selectedTemplateHelpFile = selectedTemplate.help_file;
    this.selectedTemplateHelpFilePath = `${importFilePath}/${selectedTemplate.help_file}?v=${moment(new Date()).format('YYYYMMDDHHmm')}`;
    this.selectedTemplateLabel = selectedTemplate.id;
    this.source = selectedTemplate.sample;
    this.templateColumns = (selectedTemplate.preview_table).map(objeto => objeto.field['name']);
  }

  getFileType(fileName: string) {
    const fileParts = fileName.split('.');
    if (fileParts.length > 1) {
      return '.' + fileParts[fileParts.length - 1].toLowerCase();
    }
    return '.csv, .xls, .xlsx o .txt';
  }

  confirmTemplate() {
    if (this.templateSelectForm.status === "VALID") {
      this.formatsSelected = this.getFileType(this.selectedTemplateHelpFile);
      this.isTemplateStepComplete = true;
      this.stepSelection = 2;
    }
  }

  hideMessage(element: string) {
    if (element === 'error') {
      this.errorActivatedMessage = !this.errorActivatedMessage;
    }
  }

  showErrorMessage(errorMessage: (typeof ErrorFileMessageMap)[keyof typeof ErrorFileMessageMap] = null) {
    if (errorMessage === null) {
      this.errorFileMessage = ErrorFileMessageMap.DEFAULT;
    } else {
      this.errorFileMessage = errorMessage;
    }

    // hide loading state, display error state and file input/drag&drop
    this.loadingActivatedMessage = false;
    this.errorActivatedMessage = true;
    this.isFileUploadAvailable = true;
  }

  // FILE SELECTED EVENT
  fileSelected($event: FileList) {
    // disabled step 1 while is file loading
    this.isModifyStep1ButtonAvailable = false;
    this.fileHandle($event);
  }

  // PRE PROCCESS/ PRE VALIDATION FILE SELECTED
  fileHandle(files: FileList) {
    const fileGroup: FileList = files;
    // hide file input/drag&drop, display loading state
    this.isFileUploadAvailable = false;
    this.loadingActivatedMessage = true;

    if (fileGroup.length > 1) {

      const errorMessage = ErrorFileMessageMap["Allowed number of files"];
      this.showErrorMessage(errorMessage);

    } else if (fileGroup.length === 1) {

      // hide error state if it was displayed
      this.errorActivatedMessage = false;
      // select files from array and build uploaded file object for send to file validation endpoint's form data
      const fileGroupSelected = fileGroup[0];

      this.uploadedFile = {
        file: fileGroupSelected,
        type: fileGroupSelected.type,
        name: fileGroupSelected.name,
        template: this.selectedTemplateLabel,
        customer: this.customerPuplic_key,
        description: "",
        metadata: JSON.stringify({})
      };

      // get file selected name to display
      this.fileOptionControl = fileGroupSelected.name;
      this.newFileValidation(this.uploadedFile, this.urlProcessPath);
    }
  }

  isBatchFileError(obj: any): obj is BatchFileError {
    return 'Description' in obj && 'Error' in obj;
  }

  setFileValidationMetadata() {
    return {
      "user":
        { "id": `${this.user_public_id}`, "name": `${this.userNameProcess}`, "email": `${this.userEmail}` },
      "company":
        { "id": `${this.customerPuplic_key}`, "name": `${this.userNameProcess}` }
    };
  }

  // FILE VALIDATION FROM SERVICE
  newFileValidation(uploadedFile: UploadedFile, urlProcess: string) {
    const metadata = JSON.stringify(this.setFileValidationMetadata());

    const fileValidationFormData = this.createFormData(uploadedFile, true, true, true, metadata);
    // first endpoint validate FILE
    this.newImportProcessService.newFileValidation<PaymentVersion>(fileValidationFormData, urlProcess)
      .pipe(
        takeUntil(this.destroy$),
        switchMap((result) => {
          if (this.isBatchFileError(result.batch_file) || result == undefined || result.batch_file == undefined) {
            return of("API error");
          } else {
            this.validatedFile = result;
            this.idBatch = result.batch_file.id;

            if (this.idBatch != undefined) {
              // second endpoint validate FILE DATA
              const dataValidationFormData = this.createFormData(uploadedFile, false, false, false, '');
              const dataValidationa = this.newImportProcessService.newDataValidation(dataValidationFormData, this.idBatch, urlProcess);
              return dataValidationa.pipe(catchError(error => of("API error")));
            } else {
              return of("API error");
            }
          }
        })
      )
      .subscribe({
        next: (res: "API error" | HttpResponse<DataValidation>) => {

          // first validate if response comes from API error
          if (res === "API error" || res.body == undefined || res.status == 204) {
            this.showErrorMessage();
          } else {
            const response = res;
            this.sucessActivatedMessage = this.validateFileValidationResponse(response);
          }

          this.loadingActivatedMessage = false;
          this.fileValidControl = true;
          this.isModifyStep1ButtonAvailable = true;
        }, error: err => {
          const errorMessage = err.status === 400 ? ErrorFileMessageMap[err.error] || err.error : ErrorFileMessageMap.DEFAULT;
          this.showErrorMessage(errorMessage);
          this.isModifyStep1ButtonAvailable = true;
        }
      });
  }

  validateFileValidationResponse(response: HttpResponse<DataValidation>): boolean {
    const data = response.body.data;
    const status = response.status;
    const table = response.body.table;

    if (status === 200 && data != undefined && table != undefined && table.length !== 0) {
      this.setdataPrevalidationRecords(data['descarga de errores'], data['registros con errores'], data['registros correctos'], data['registros en blanco'], data['total registros'], data['duplicados']);
      this.fieldPrevalidationWarningMessage = data['registros con errores'] > 0;
      this.prevalidationColumns = this.getColumnsName(table);
      this.prevalidationSource = table.slice(0, 5);
      return true;
    } else if (status === 201 && data !== undefined) {
      this.setdataPrevalidationRecords('', 0, 0, 0, data['total registros']);
      return true;
    } else {
      this.showErrorMessage();
      return false;
    }
  }

  getColumnsName(arr: DataValidationTable): string[] {
    return Object.keys(arr[0]);
  }

  setdataPrevalidationRecords(link: string = "", errors: number = 0, correct: number = 0, blanck: number = 0, total: number = 0, duplicate = 0) {
    this.dataPrevalidationRecords = {
      'descarga de errores': link,
      'registros con errores': errors,
      'registros correctos': correct,
      'registros en blanco': blanck,
      'total registros': total,
      'duplicados': duplicate
    };
  }

  // CONFIRM FILE FROM STEP 2 TO STEP 3
  confirmFile() {
    if (this.fileSelectForm.status === "VALID") {
      this.isFileStepComplete = true;
      this.stepSelection = 3;
      this.fileRenderStep3(this.validatedFile);
    }
  }

  fileRenderStep3(validatedFile) {
    // display file data
    this.fileRenderSource = validatedFile.table;
    this.fileRenderColumns = validatedFile.headers;
    // display amount attributes
    this.amountAttributes = this.templateColumns.length;
    this.buildCustomFieldMappingForm(this.fieldListArray, this.fileRenderColumns, this.templateColumns);
  }

  // push field groups in field list array form from step 1 template columns
  buildCustomFieldMappingForm(fieldListArray: FormArray, fileRenderColumns: string[], templateColumns: string[]) {
    templateColumns.forEach(column => {
      this.addFieldGroup(fieldListArray, column, fileRenderColumns);
    });

    return fieldListArray;
  }

  // build and push form group
  // field: match between file header and template header, return null if don't match
  // newFieldName: template header
  addFieldGroup(fieldListArray: FormArray, templateColumn: string, fileRenderColumns: string[]) {
    const fieldValue = this.setFieldValueMatch(fileRenderColumns, templateColumn);

    fieldListArray.push(this.formBuilder.group({
      field: new FormControl(fieldValue, [Validators.required]),
      newFieldName: new FormControl(templateColumn)
    }));
  }

  setFieldValueMatch(fileRenderColumns: string[], fieldName: string) {
    const value = fileRenderColumns.filter(el => el === fieldName)[0];
    return value || null
  }

  changeFieldToMapping(event: MatSelect) {
    this.checkForDuplicates(this.fieldListArray);
  }

  checkForDuplicates(arrayForm: FormArray) {
    const fieldListArray = arrayForm;

    for (const personFormGroup of fieldListArray.controls) {
      personFormGroup.get('field').setErrors(null);
    }

    const values = fieldListArray.controls.map((control: FormGroup) => {
      const field = control.get('field').value;
      return { field };
    });

    for (let i = 0; i < values.length; i++) {
      for (let j = i + 1; j < values.length; j++) {
        if (
          (values[i].field === values[j].field) && (values[i].field != null && values[j].field != null)
        ) {
          fieldListArray.controls[i].get('field').setErrors({ duplicate: true });
          fieldListArray.controls[j].get('field').setErrors({ duplicate: true });
        }
      }
    }
  }

  // CONFIRM INPUT MAPPING FROM STEP 3 TO STEP 4
  confirmInput(fieldMappingForm: FormGroup) {
    if (this.fieldMappingForm.status === "VALID") {
      this.stepSelection = 4;
      this.isFieldMappingComplete = true;
      this.fieldMappingLoadingMessage = true;
      this.newFieldValidation(fieldMappingForm, this.uploadedFile);
    }
  }

  // FIELD VALIDATION FROM SERVICE
  newFieldValidation(fieldMappingForm: FormGroup, uploadedFile: UploadedFile) {
    const fieldValidationFormData = this.createFormData(uploadedFile, false, false, true, JSON.stringify(fieldMappingForm.value.fieldList));
    this.newImportProcessService.newFieldValidation(fieldValidationFormData, this.urlProcessPath, this.idBatch)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: res => {
          if (res && res.batch_file && res.batch_file.id) {
            this.idBatchConfirm = res.batch_file.id;
            this.confirmImportAvailable = true;
          } else {
            this.fieldMappingErrorMessage = true;
          }
          this.fieldMappingLoadingMessage = false;
        },
        error: error => {
          this.fieldMappingLoadingMessage = false;
          this.fieldMappingErrorMessage = true;
          console.error('Failed! while trying to validate field. ' + error)
        }
      })
  }

  confirmImport() {
    this.spinnerService.show();
    const confirmImportProcess = this.processService.ProcessImportParse(this.idBatchConfirm);
    confirmImportProcess
      .pipe(
        takeUntil(this.destroy$),
        timeout(10000),
        tap((res: number) => {
          const newRoute = '/customers';
          this.customRedirect(newRoute);
        }),
        catchError(error => {
          if (error.name === 'TimeoutError') {
            this.customRedirect('/customers');
          } else {
            this.fieldMappingLoadingMessage = false;
            this.fieldMappingErrorMessage = true;
            this.spinnerService.hide();
          }
          console.error('Failed! while trying to process batch. ' + error);
          return of(null);
        })
      )
      .subscribe();
  }

  customRedirect(path: string) {
    if (this.designVersion === 'V2') {
      this.navigateToLayout('Proceso por lotes', false)
    } else {
      this.goToCustomRoute(path);
    }
  }

  navigateToLayout(tabName: string, skipQuery = true) {
    const state: {
      title: string;
      description?: string;
    } = {
      title: 'La importación ha terminado',
      description: 'Todos los datos han sido cargados exitosamente. Ahora puedes proceder a revisar y gestionar la información importada.'
    };

    let config: any = {
      queryParams: { tabName: tabName }
    };

    if (!skipQuery) {
      config = {
        ...config,
        state: state
      };
    }

    this.router.navigate(['/new_configuration_layout'], config);
  }

  goToCustomRoute(newRoute: string) {
    const state: {
      title: string;
      body?: string;
    } = {
      title: 'La importación ha terminado'
    };

    return this.router.navigate([newRoute], {
      state: state
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

